<template>
  <v-container 
    tag="section"
    fluid
  >
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row align="center">
        <v-col cols="12">
          <parametros-normas-tecnicas
            ref="parametrosNormasTecnicas"
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-normas-tecnicas"
            color="success"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarNormas()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import NormasTecnicasService from "@/services/parametrosComCa/NormasTecnicasService";

export default {
  name: "EditNormasTecnicas",

  components: {
    ParametrosNormasTecnicas: () => import("@/components/parametrosComCa/normasTecnicas/ParametrosNormasTecnicas.vue"),
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  
  methods: {
    getFormattedNormas(normas) {
      /*
        Formato desejado:
        $equipamento: { $COM: {$tipologia: $qtd} }...
        Exemplo:
        "BC":{"CHFUS":{"RAR":"17171717","RAU":"3.004"},"CRUZETA":{"RAR":"0.001","RAU":"0.001"},"PR":{"RAR":"3.001","RAU":"3"}}...
      */

      let normasJson = {};
      
      normas.forEach(el => {
        if (normasJson[el.equipamento] == undefined) {
          normasJson[el.equipamento] = { 
            [el.componente_menor]: { 
              [el.tipologia]: el.quantidade
            }
          };
        } else if (normasJson[el.equipamento][el.componente_menor] == undefined) {
          normasJson[el.equipamento][el.componente_menor] = {
            [el.tipologia]: el.quantidade
          };
        } else if (normasJson[el.equipamento][el.componente_menor][el.tipologia] == undefined) {
          normasJson[el.equipamento][el.componente_menor][el.tipologia] = el.quantidade
        }
      });

      return normasJson;
    },
    salvarNormas() {
      const id = !this.$route.params.id ? null : this.$route.params.id;
      const ref = this.$refs.parametrosNormasTecnicas;

      const postData = {
        nome: ref.nome,
        arquivoId: ref.origem == 'arquivo' ? ref.arquivo.id : null,
        nomeArquivo: ref.origem == 'arquivo' ? ref.arquivo.fileObj.name : null,
        delimitador: ref.arquivo.delimitador,
        involucro: ref.arquivo.involucro,
        escape: ref.arquivo.escape,
        parametros: { "normas_quantidades_com": this.getFormattedNormas(ref.normas) },
      };
      
      this.loading = true;
      
      NormasTecnicasService.salvarNormasTecnicas(postData, id)
        .then(() => {
          this.$toast.success('Normas Técnicas salvas com sucesso.', '', { position:'topRight' })
          this.$router.push({ name: 'Normas Técnicas' });
        })
        .catch(error => {
          console.error(error);
          if (error?.data?.error_code == 1001) {
            this.$toast.error(error.data.erro, "", { position: "topRight", timeout: 6000 });
          }else{
            this.$toast.error('Erro ao salvar Normas Técnicas.', '', { position:'topRight' });
          }
          this.$refs.parametrosNormasTecnicas.arquivo.fileObj = undefined;
        })
        .finally(() => this.loading = false);
    },
  },
}
</script>

<style>
  .v-alert__icon {
    align-self: center;
  }
</style>